import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { stopCrossAppImpersonation } from "@/api/impersonation/impersonationApi";

const Logout: React.FC = () => {
  const { logout, getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    const performLogout = async () => {
      localStorage.removeItem("selectedCompanyUuid");

      // Clear impersonation metadata before logging out
      try {
        const token = await getAccessTokenSilently();
        const payload = JSON.parse(atob(token.split(".")[1]));
        const sgiClaims = payload["http://hub.sgi.com/jwt/claims"] ?? {};
        if (sgiClaims["sgi_hub_impersonate_sso_id"]) {
          await stopCrossAppImpersonation();
        }
      } catch {
        // If token fetch fails, proceed with logout anyway
      }

      logout({
        logoutParams: {
          returnTo: window.location.origin,
        },
      });
    };

    performLogout();
  }, [logout, getAccessTokenSilently]);

  return <div>Logging out...</div>;
};

export default Logout;
